import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FieldArray, Formik } from 'formik';
import { Container } from 'react-bootstrap';

import { MaskInput } from 'modules/shared/Forms';
import AdminTop from 'modules/admin/components/AdminTop';
import FormikFillFields from 'modules/shared/Forms/FormikFillFields';
import TitleUndescore from 'modules/shared/TitleUndescore';
import FormikPatchTouched from 'modules/shared/Forms/FormikPatchTouched';
import Loader from 'modules/kiosk/components/Loader';
import { useModal } from 'modules/shared/hooks';
import ErrorMsg from 'modules/shared/ErrorMsg';
import { labelsGlobalSet } from './constants';
import settingsSchema from './schema';
import { settingsGlobSelector } from './selectors';
import { getGlobalSetError, getGlobalSetRequest, putGlobalSetRequest } from './actions';
import { usePrepareSettings } from './hooks/usePrepareSettings';

const SettingsContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { error, loading, settings } = useSelector(settingsGlobSelector);

  const { isShow, openModal, closeModal } = useModal();
  const initValues = usePrepareSettings(settings);

  useEffect(() => {
    dispatch(getGlobalSetRequest());
  }, []);

  useEffect(() => {
    if (error) {
      return openModal();
    }
    closeModal();
  }, [error]);

  return (
    <Container className="my-4">
      {loading && <Loader />}

      {!loading ? (
        <Formik
          initialValues={initValues}
          validationSchema={settingsSchema}
          validateOnMount
          enableReinitialize
          onSubmit={(values) => {
            dispatch(putGlobalSetRequest(values));
          }}
        >
          {({ values, handleSubmit, handleChange }) => (
            <form onSubmit={handleSubmit}>
              <FormikPatchTouched />
              <FormikFillFields />
              <AdminTop title="Глобальні налаштування" onSave={handleSubmit} />

              {/* <div className="my-5"> */}
              {/*  <TitleUndescore title="Сервіс СМС" /> */}
              {/*  <div className="m-0 pl-4 pr-0 col-12 mb-4"> */}
              {/*    <Textarea */}
              {/*      className={styles.textarea} */}
              {/*      name="messageText" */}
              {/*      label="Текст повідомлення" */}
              {/*      maxLength={150} */}
              {/*      onChange={handleChange} */}
              {/*      onLine */}
              {/*    /> */}
              {/*  </div> */}
              {/* </div> */}
              <div className="my-5">
                <TitleUndescore title="Групи Azure" />
                <div className="m-0 pl-4 col-12 mb-4">
                  <FieldArray
                    name="aadRoles"
                    render={() =>
                      values?.aadRoles?.map((v: any, index: number) => {
                        const { roleId } = v;

                        if (Object.keys(labelsGlobalSet).includes(`${roleId}`))
                          return (
                            <MaskInput
                              key={roleId}
                              name={`aadRoles[${index}].objectId`}
                              // @ts-ignore
                              label={labelsGlobalSet[`${roleId}`]}
                              maskPlaceholder=""
                              mask="########-####-####-####-############"
                              className="mb-2"
                              maxLength={36}
                              isRequired
                              value={v.objectId}
                              onChange={handleChange}
                              disabled={roleId === 5}
                            />
                          );

                        return true;
                      })
                    }
                  />
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : null}

      <ErrorMsg
        isShow={isShow}
        closeHandler={() => {
          closeModal();
          dispatch(getGlobalSetError(null));
        }}
        // @ts-ignore
        error={error?.message || 'Виникла помилка'}
      />
    </Container>
  );
};

export default SettingsContainer;
